const words = [
	"CONSULT",
	"DEVELOP",
	"IMPLEMENT",
	"CUSTOMISE",
	"SUPPORT",
	"TEACH"
];

export function mountWordRotator(root) {
	const headline = root.querySelector(".cd-headline.slide") || root.querySelector("#hero-title");
	if (!headline) return () => {};

	let wrapper = headline.querySelector(".cd-words-wrapper");
	if (!wrapper) {
		const legacyWord = headline.querySelector(".solufy-rotating-word");
		if (legacyWord) {
			legacyWord.outerHTML = `<span class="cd-words-wrapper" aria-live="polite"><b class="is-visible">${legacyWord.textContent.trim() || words[0]}</b>${words.slice(1).map((w) => `<b>${w}</b>`).join("")}</span>`;
			wrapper = headline.querySelector(".cd-words-wrapper");
		}
	}
	if (!wrapper) return () => {};

	let wordElements = [...wrapper.querySelectorAll("b")];
	if (wordElements.length === 0) {
		wrapper.innerHTML = words
			.map((w, i) => `<b class="${i === 0 ? "is-visible" : ""}">${w}</b>`)
			.join("");
		wordElements = [...wrapper.querySelectorAll("b")];
	}

	if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
		wordElements.forEach((word, index) => {
			word.classList.toggle("is-visible", index === 0);
			word.classList.remove("is-hidden");
		});
		wrapper.style.width = "auto";
		return () => {};
	}

	let currentIndex = wordElements.findIndex((b) => b.classList.contains("is-visible"));
	if (currentIndex === -1) {
		currentIndex = 0;
		wordElements[0].classList.add("is-visible");
	}

	const updateWidth = (b) => {
		if (!b) return;
		const rect = b.getBoundingClientRect();
		const w = Math.max(rect.width, b.offsetWidth || 0, b.scrollWidth || 0);
		if (w > 0) {
			wrapper.style.width = `${Math.ceil(w) + 16}px`;
		}
	};

	// Set initial width
	updateWidth(wordElements[currentIndex]);
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(() => {
			updateWidth(wordElements[currentIndex]);
		});
	}

	let timeout = null;
	const interval = window.setInterval(() => {
		if (document.hidden) return;

		const currentWord = wordElements[currentIndex];
		currentIndex = (currentIndex + 1) % wordElements.length;
		const nextWord = wordElements[currentIndex];

		// Trigger vertical sliding transitions
		currentWord.classList.remove("is-visible");
		currentWord.classList.add("is-hidden");

		nextWord.classList.remove("is-hidden");
		nextWord.classList.add("is-visible");

		updateWidth(nextWord);

		if (timeout) clearTimeout(timeout);
		timeout = window.setTimeout(() => {
			currentWord.classList.remove("is-hidden");
		}, 650);
	}, 2800);

	const onResize = () => {
		updateWidth(wordElements[currentIndex]);
	};
	window.addEventListener("resize", onResize, { passive: true });

	return () => {
		window.clearInterval(interval);
		if (timeout) window.clearTimeout(timeout);
		window.removeEventListener("resize", onResize);
	};
}
